import React from 'react'
import {useParams, useNavigate} from "react-router-dom";
import InactivityLogout from '../services/InactivityLogout';
import Header from '../components/Header';
import MaropostSection from '../components/maropostSection';



export default function Maropost() {

  const {email} = useParams();
  const navigate = useNavigate();
  return (
    <>
      <InactivityLogout>
      <Header searchterm={email} />
      <MaropostSection searchterm={email} navigate={navigate} />
      </InactivityLogout>
    </>
  )
}
